import React, { useState } from "react";

import OutlinedInputCustom from "../utility/component/textInput";
import { AccountMasterHelp } from "../help";
import { emptyRowDetails } from "./fun";
import uniqueId from "uniqid";
import { useDispatch } from "react-redux";
import { setAlertWithTitle } from "../utility/Redux/modal";
import moment from "moment";
import ListCreditNoteHelp from "../help/listCreditHelp";
const PartyDetails = ({
  partyDetails,
  setPartyDetails,
  loadPurchaseBill,
  accountMasterHelpStatus,
  setAccountMasterHelpStatus,
  rows,
  setRows,
  delayedFunction,
  partyNameRef,
  issueToRef,
  setIssueToRef,
  setIssuedByRef,
  setAlertTwoButtonModal,
}) => {
  const dispatch = useDispatch();
  const [IssueBillHelpStatus, setIssueBillHelpStatus] = useState(false);
  return (
    <div className="flex h-auto w-full flex-col gap-3 py-2 xl:flex-row">
      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className="w-full bg-[#ffffff] px-3 pb-3 pt-3 xl:w-auto"
      >
        <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-[200px,150px]">
          <OutlinedInputCustom
            readOnly={true}
            value={partyDetails.CREDIT_NOTE_NO}
            label={"Credit Note No."}
            fontWeight={600}
            search={() => {
              setIssueBillHelpStatus(true);
            }}
          />

          <OutlinedInputCustom
            type={"date"}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d{4}-\d{2}-\d{2}$/.test(inputValue)) {
                setPartyDetails((prevState) => ({
                  ...prevState,
                  DATE: inputValue,
                }));
              }
            }}
            value={partyDetails.DATE}
            label={"Date"}
          />
        </div>
      </div>

      <div
        style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
        className="grid w-full flex-1 grid-cols-1 gap-3 bg-white p-3 sm:grid-cols-2 xl:grid-cols-[190px,minmax(250px,1fr)]"
      >
        <div className="">
          <OutlinedInputCustom
            search={() => {
              setAccountMasterHelpStatus(true);
            }}
            width={`calc(100% - 0px)`}
            value={partyDetails.ACCOUNT_NO}
            label={"Acc. Number"}
            readOnly={true}
            autoFocus={true}
            refrance={partyNameRef}
            onKeyDown={(e) => {
              if (e.code === "Enter" || e.code === "NumpadEnter") {
                if (partyDetails.ACCOUNT_NO) {
                  setIssueToRef(true);
                } else {
                  setAccountMasterHelpStatus(true);
                }
              }
            }}
          />
        </div>

        <OutlinedInputCustom
          width={`calc(100% - 0px)`}
          value={partyDetails.NAME}
          label={"Party Name"}
          refrance={issueToRef}
          readOnly={true}
          onKeyDown={(e) => {
            if (e.code === "Enter" || e.code === "NumpadEnter") {
              setIssuedByRef(true);
            }
          }}
        />
      </div>

      <AccountMasterHelp
        onRowClick={(row) => {
          if (!rows.find((r) => r.ITEMNAME)) {
            setAccountMasterHelpStatus(false);
            setRows([
              {
                ...emptyRowDetails,
                id: uniqueId(),
              },
            ]);
            setIssueToRef(true);
            setPartyDetails((old) => {
              return {
                CREDIT_NOTE_NO: "",
                DATE: old.DATE || moment().format("YYYY-MM-DD"),
                ACCOUNT_NO: row.row.ACCOUNT_NO,
                NAME: row.row.NAME,
              };
            });

            setTimeout(() => {
              setIssueToRef(true);
            }, 500);
          } else {
            setAccountMasterHelpStatus(false);
            dispatch(
              setAlertWithTitle({
                title: "Alert",
                msg: "Please clear items before changing account",
              })
            );
          }
        }}
        status={accountMasterHelpStatus}
        onClose={() => {
          setAccountMasterHelpStatus(false);
        }}
      />
      <ListCreditNoteHelp
        onRowClick={(row) => {
          setIssueBillHelpStatus(false);
          const selectedCreditNoteNo = row.row.CREDIT_NOTE_NO;
          const hasFormData =
            partyDetails.ACCOUNT_NO ||
            partyDetails.CREDIT_NOTE_NO ||
            rows.some((item) => item.ICODE || item.ITEMNAME || item.REMARKS);
          const loadSelectedCreditNote = () => {
            delayedFunction(rows[0].id);
            loadPurchaseBill(selectedCreditNoteNo);
          };

          if (hasFormData) {
            setAlertTwoButtonModal({
              title: "Replace current credit note?",
              msg: "Unsaved changes on the current form will be discarded.",
              status: true,
              button1: "Continue",
              button2: "Cancel",
              button1Click: () => {
                setAlertTwoButtonModal((current) => ({
                  ...current,
                  status: false,
                }));
                loadSelectedCreditNote();
              },
              button2Click: () => {
                setAlertTwoButtonModal((current) => ({
                  ...current,
                  status: false,
                }));
              },
            });
          } else {
            loadSelectedCreditNote();
          }
        }}
        status={IssueBillHelpStatus}
        onClose={() => {
          setIssueBillHelpStatus(false);
        }}
      />
    </div>
  );
};

export default PartyDetails;
